<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [
            {
              "num_cand": "U2FsdGVkX18iUZNvB/hQckNODGrQTqwEnqslGnmlTCQ=",
              "cpf": "U2FsdGVkX1+LDGdejCuCFATznZJxa4LYOdXVY29+6sE="
            }, {
            "num_cand": "U2FsdGVkX19/oykrxJ6h1LlnOg22dDTqUg69j5VRtA4=",
            "cpf": "U2FsdGVkX18wI49os3GLatFrvvJcKmCcUFrM/MBUfQQ="
          }, {
            "num_cand": "U2FsdGVkX1+r+Z8Pd6l/4txkh9HW9ha7lepE74Wc8Jg=",
            "cpf": "U2FsdGVkX18H+/s91DJKeskmhzf2bDfEe73/53Y6C70="
          }, {
            "num_cand": "U2FsdGVkX1+ek3jTYg7EPMRuSzX1MRJ40FaakulQP/A=",
            "cpf": "U2FsdGVkX19F4DHCtrSgnAwGtgssfrrGpq+sLnrehMY="
          }, {
            "num_cand": "U2FsdGVkX19bzpE5JHwv5eHizA4zgpXd4sf+gI59cIw=",
            "cpf": "U2FsdGVkX1/uzuUuk7ihVOBxpfeY7nsJfgafGw8zzXY="
          }, {
            "num_cand": "U2FsdGVkX189jAJ8IzVdmzdnjdV92xp6Z1+bKckjvkI=",
            "cpf": "U2FsdGVkX19sOTt3kcpny4ua9Y/pIe+q9QXlIe7cEzs="
          }, {
            "num_cand": "U2FsdGVkX18M62Nm2fXkXoqvfV7m1aIP6+S+tRz59nE=",
            "cpf": "U2FsdGVkX19ZntMOG1vV3VFdJcR3LIeMk1QATze1Dxc="
          }, {
            "num_cand": "U2FsdGVkX19f763UqhUJrlCw8DqWSInYacvFZqw7E60=",
            "cpf": "U2FsdGVkX1/ovJefelcCBqgrNt9Q+1eB75Z69x5xp0Y="
          }, {
            "num_cand": "U2FsdGVkX1+o6VElI5YM1Ati+ne8XXmoNHzOpoFasno=",
            "cpf": "U2FsdGVkX1+jF3ZwZ54p25rry+GWJzOpvcJKOp4Md6g="
          }, {
            "num_cand": "U2FsdGVkX19W8/3rzYH9P3ky0RTSUldfPMa6jg98m/o=",
            "cpf": "U2FsdGVkX185ZxPlpKOETbAlOnrAv4hYspt6JEmnqe8="
          }, {
            "num_cand": "U2FsdGVkX1/jjBCCMANriCMwYSfHLBBAsjusxjEdKf0=",
            "cpf": "U2FsdGVkX1+3E5bjRfsrC3l8ZIO1kvUW89/U/X4ckEc="
          }, {
            "num_cand": "U2FsdGVkX1+JgdVb0cgTmYnHjWdmMwlWbfu9FNdx8+Q=",
            "cpf": "U2FsdGVkX1+5DsqKVTx9jUPi0uSmH25iezM+v0t/OXA="
          }, {
            "num_cand": "U2FsdGVkX1/iO86BHK5vkgQm0j6dv5Mz1i9NbZJvgK8=",
            "cpf": "U2FsdGVkX186A1UIO3X7v7lzF7YKpL3lTxukLBEX0Wg="
          }, {
            "num_cand": "U2FsdGVkX1/i6MW10ZYeqaSrf9blG2KW9CurBZ4PvNU=",
            "cpf": "U2FsdGVkX18hxogQ2rV0JDwAoEyqfF51yaYmTeSukRk="
          }, {
            "num_cand": "U2FsdGVkX19f0605RX7lQ2TTPnFI8GffV5xE4pweUMU=",
            "cpf": "U2FsdGVkX1+SNY9OW0JCIzD+g4t3TBzEPEcpfr9Zczs="
          }, {
            "num_cand": "U2FsdGVkX18kBcTuebDa4cekXLyVWSCwAOSJKGukD2w=",
            "cpf": "U2FsdGVkX19gnRM5/OVhNl9tjk/PZCyF6ZKGhL+cklo="
          }, {
            "num_cand": "U2FsdGVkX1/kzH1cxenV44NqLUE8Q+sc1dWWI3fwlFk=",
            "cpf": "U2FsdGVkX183Vpeehx+bSUM56krQ7wyQ6nn9Pc7oaEk="
          }, {
            "num_cand": "U2FsdGVkX1/m+Ve5l2w1QvqDvxio1mkCfUGNfNw8Jww=",
            "cpf": "U2FsdGVkX1//crX3q5Ji3QN0fXc6xcQ9U5hxhUWOCYk="
          }, {
            "num_cand": "U2FsdGVkX1/qERoRgXkOmS5rkon/LIoyhfAVyS2h5JM=",
            "cpf": "U2FsdGVkX19HxULYPfpVCmGe/1R0ow1VD8x7DYhWxlU="
          }, {
            "num_cand": "U2FsdGVkX1/o6uxq7v0T3E+34TIAmxCc8/WKhu/M8Rk=",
            "cpf": "U2FsdGVkX18fjtk8EIDpwvqK8XSaWruMLTQbAAHgtx8="
          }, {
            "num_cand": "U2FsdGVkX1/MYvjlXj4RMlZh2h95OtilSHk+FPhKe34=",
            "cpf": "U2FsdGVkX1/K5uzyK8LfnqIB/MduWvdZ4Rt0ojvlBgY="
          }, {
            "num_cand": "U2FsdGVkX1/YloIJH+Upwolb1R9tZSHP0kmGNGBERdo=",
            "cpf": "U2FsdGVkX1+W9F3zuxzewNbNLgnBoZnrZOXF5G9/nsM="
          }, {
            "num_cand": "U2FsdGVkX19F0Hhv7HUT+4PZAdQ1GTpELIaBVsJPHUc=",
            "cpf": "U2FsdGVkX1+BMkEjb2wCai1rNgr+UJ0umeUbHHCdK+w="
          }, {
            "num_cand": "U2FsdGVkX1+4xmI7sL1d6yiKoyc3JnY/wcf053KTKaw=",
            "cpf": "U2FsdGVkX19Ull/Pu7zEeAx7BFEixG+iY9AZzt8leeY="
          }, {
            "num_cand": "U2FsdGVkX18uzj/BMNJL44L+S/LC5ZMpNTA3x9qvCQc=",
            "cpf": "U2FsdGVkX1+f3Scz2VcCT6USC5AMG0BrZhBraUTsmWY="
          }, {
            "num_cand": "U2FsdGVkX19qNUsRn+mVuyHXuJs8dxF5oxkL3xxmLTY=",
            "cpf": "U2FsdGVkX1+7fMYp8FtJLkTqQb4SF2hXw9Dp7+lIi/0="
          }, {
            "num_cand": "U2FsdGVkX1+fQtuXskWY10vw5PhTWftjK5fhLS8Bm7M=",
            "cpf": "U2FsdGVkX1/5Hi6I6OJlPEEtKNEO3KYs6NX8CvVTwvI="
          }, {
            "num_cand": "U2FsdGVkX1/5qBdUIgx4nrK8yB5YIQXU/OIVKh0irgc=",
            "cpf": "U2FsdGVkX19ZurxbhjQFIK9kqHYTkTiFVSXaAmbALRI="
          }, {
            "num_cand": "U2FsdGVkX19MSu5D0iqJuw++j6drrgXYmqDTy8Q9+4c=",
            "cpf": "U2FsdGVkX186gOr9erFhXUrzglI0AHxhUF87VI8w2jc="
          }, {
            "num_cand": "U2FsdGVkX1/w8CvDwrBqm2vm92G89/DH+JNarIA6IqQ=",
            "cpf": "U2FsdGVkX19mFoFpDzTBH20JVxypHBlA3ym5DsvPuA0="
          }, {
            "num_cand": "U2FsdGVkX19yzXzrJDiw5NkPwRJSwssC53MafKlpGzM=",
            "cpf": "U2FsdGVkX19FtRNfzA9ECMIQyrNV5rWAuqES2DuNpv4="
          }, {
            "num_cand": "U2FsdGVkX19wQAKEwSxANTUTZFxO5iEV0yuQ8Z+Gxq8=",
            "cpf": "U2FsdGVkX1+hB7ywVR/mmUCoHTQnebndfERXf8eujRE="
          }, {
            "num_cand": "U2FsdGVkX18nScG2zoI5CCq1Gy91n+2/XH6zEpbhEr8=",
            "cpf": "U2FsdGVkX1+9JATzxZJB8f+YMZxEvh/zTr7Lsc9NLP8="
          }, {
            "num_cand": "U2FsdGVkX19xCDFASNWenSnlHqonK2GNYfSC1QmSAB0=",
            "cpf": "U2FsdGVkX1/z0hv4YC2bhWpuyHOs7Z3f74UfPKp/Go0="
          }, {
            "num_cand": "U2FsdGVkX1+MEwe2LZcUEnvPSEqB3Zh51NA46oTYeqU=",
            "cpf": "U2FsdGVkX18+3XROGOcJd0HTrK8IWkcUNpxTkPKI1YE="
          }, {
            "num_cand": "U2FsdGVkX1+KWKIlOprduUeIgiScQmH/DLmLAE/YaDc=",
            "cpf": "U2FsdGVkX18bfIRlzyJk1XS55hoVIHPUOkpJajgfzVg="
          }, {
            "num_cand": "U2FsdGVkX18dhb9VHAEcG7hvR+Ou8vCaKHXqn2I8Dho=",
            "cpf": "U2FsdGVkX1+lfP9Hre+LNd+hOIKTEcJU5tJyRQXRWiA="
          }, {
            "num_cand": "U2FsdGVkX18f6syLODqwSKOu2MoYG4Dj2CXhibTiFZE=",
            "cpf": "U2FsdGVkX1+tHTYWbplkRY8H9vLKUc5qRsxvnaTrIDE="
          }, {
            "num_cand": "U2FsdGVkX1/6DJ8P34oYYX5iW6v7jIQgABE5ZPbRopE=",
            "cpf": "U2FsdGVkX1++MSbOmZBgBIpy9jCvIbYCM5k5fBRU7Mc="
          }, {
            "num_cand": "U2FsdGVkX194zly2PTbZaJA0XF5zdGcGqIggy19Ub2Y=",
            "cpf": "U2FsdGVkX19aqRtf9/1hKKTO4NUTGjWa7IwBBAB4T04="
          }, {
            "num_cand": "U2FsdGVkX19o5KThPgFYjK0vG0sCvyYQsA4afOpOvO0=",
            "cpf": "U2FsdGVkX18qokn96dhaBZf2MdWlf24vqFEVXhY97KI="
          }, {
            "num_cand": "U2FsdGVkX18CYD84liu8xj4XKs4s0zFfKzdDkx5ZJw8=",
            "cpf": "U2FsdGVkX1+t1qGIG0TMgTWa55/qtEvFsYpnmvUWNaE="
          }, {
            "num_cand": "U2FsdGVkX18tsMHht6hEEMhLKMRbQywp2OCJPlW4xok=",
            "cpf": "U2FsdGVkX1/vKORloO+QgWYjQ/6jyUg498mzZx0PPvk="
          }, {
            "num_cand": "U2FsdGVkX181RKchQpU/smZAF8XHIEDWVOE5HcZE4HI=",
            "cpf": "U2FsdGVkX19BSiy6RvbJpbrJY2GFZS1vYNBAhwuYHMs="
          }, {
            "num_cand": "U2FsdGVkX1/CQn96b0NfN3KBX18mXCzaU2IiXcSIPtw=",
            "cpf": "U2FsdGVkX18WgZWsdcPFlaG6kQq7hvo7PgvAW6iTKag="
          }, {
            "num_cand": "U2FsdGVkX1/wyEeY2BVtke+Ftfu9Zb/92x6i0nvFmqw=",
            "cpf": "U2FsdGVkX1+nDmrPpv4gjMgNK5gOG37zpN0s3ptBr3g="
          }, {
            "num_cand": "U2FsdGVkX18DtG5TvibtcQ8loNGBpyg8pX7G/nU+hEE=",
            "cpf": "U2FsdGVkX19sXqoKQD+KBBe35MLGfX0ZcwkKci6FfIk="
          }, {
            "num_cand": "U2FsdGVkX196HZfSQ+QpNTdPao/ELQ9In83anyS25ZE=",
            "cpf": "U2FsdGVkX19QjO7nbOaq6Q7CsGhnvOetUP8n7W1FaRg="
          }, {
            "num_cand": "U2FsdGVkX1+FD7FvTiMdLmzySyjw9aJ3nPoDA3ppNpA=",
            "cpf": "U2FsdGVkX1/I/GmPXddb37SslWJG/jCJMOlcnyH+LfQ="
          }, {
            "num_cand": "U2FsdGVkX19bgsX439ure4nbig3KEi+/rhAoeOf1BbQ=",
            "cpf": "U2FsdGVkX18jOHGJKhFhvz47rqE11z52+RZExVIFboE="
          }, {
            "num_cand": "U2FsdGVkX19Bi+PaJVYFptCN088iwDmrQXQSsE5imDU=",
            "cpf": "U2FsdGVkX1+xLVnKvhY9DWYhKAELqPR3LelziyJlcp8="
          }, {
            "num_cand": "U2FsdGVkX1/ntD6jQIFHrbe39GumGUVLY4+c1iukwxY=",
            "cpf": "U2FsdGVkX1/hOIEVf+eY0jP4zlFQLk9nILTTDJ3WVOg="
          }, {
            "num_cand": "U2FsdGVkX18qgbINVbBtnkxolY/3jHWGgI6jTfu+YXo=",
            "cpf": "U2FsdGVkX1+wo1828Nkvgyf2E+nQU/6edGuQmDDlGSk="
          }, {
            "num_cand": "U2FsdGVkX1+mwQp/6sPJzwMC/5GdFgldjpq42si4slg=",
            "cpf": "U2FsdGVkX1/ue/5jnbDH7jin/wcNdg+qLKsjzV1B45A="
          }, {
            "num_cand": "U2FsdGVkX18mAjBMPUzHc6Cilp2Gv/XTh/LlAkV4IDI=",
            "cpf": "U2FsdGVkX19CwZf0aUsGs6dC7270vui/A33aI0jmcs0="
          }, {
            "num_cand": "U2FsdGVkX1+kjNEbLM/vxCqv4OJZM00Opo8u77JyL9o=",
            "cpf": "U2FsdGVkX1/lxENEgrQgjAjngADVWYL8oP+lxEQ4hYk="
          }, {
            "num_cand": "U2FsdGVkX18zwd42fcRu9dB0rCrlqY681x+03cLU35g=",
            "cpf": "U2FsdGVkX18QYwJ9oWUhZEmy1GdClglCjQoUEAaJmBQ="
          }, {
            "num_cand": "U2FsdGVkX1+yD1XfP4BXVmVFKbPsDRohTbXYVgDI5B4=",
            "cpf": "U2FsdGVkX1/GTyJOnErJYqwlwWO0cdIK1BujxZ+jaXU="
          }, {
            "num_cand": "U2FsdGVkX19a2ru8cfdZyzYe5VZcdNj/2AOUM9x6GkA=",
            "cpf": "U2FsdGVkX18qxocJzKQNSItsGuAqUSqe2U+PMB2f6v4="
          }, {
            "num_cand": "U2FsdGVkX1+hWQ4AMC5s4IQfNXeaBVmDAZI5MXAV0gI=",
            "cpf": "U2FsdGVkX1/PJN12dOxkunbWCaSYrHTdPjX7aztyW0o="
          }, {
            "num_cand": "U2FsdGVkX19OARe5KOcqgqa9r4SN01X5fOIADt2yun8=",
            "cpf": "U2FsdGVkX1/jz7NTiLnQ2Iv5YRM+Z3rAARAUaPerPLk="
          }, {
            "num_cand": "U2FsdGVkX18k2BD/UfpqixiYQX3wi+zjY7WdbncLk8g=",
            "cpf": "U2FsdGVkX1/V5YBLzp9KWdx1K5Wokoy+nImQbDB+x9g="
          }, {
            "num_cand": "U2FsdGVkX1+arwV/W+SwbejjU7/9WxfIol0l6rQ2iBM=",
            "cpf": "U2FsdGVkX1+unttzL2oSX2UbE7FJuo5R5N9l210F8Qw="
          }, {
            "num_cand": "U2FsdGVkX18wZgKoccBUPkoGEWRlD+uSHoRmFaKpQGg=",
            "cpf": "U2FsdGVkX18WNRR9pBWiM1ZFW0wphK6OWK10ZV5WoP4="
          }, {
            "num_cand": "U2FsdGVkX1/W0Nxr2vvePwoVMoB2lACG/qSaXy07rrU=",
            "cpf": "U2FsdGVkX1/RHCKOlHKaweZ8mHA1uukCVxzQkS1odjs="
          }, {
            "num_cand": "U2FsdGVkX19doHOgaSx5vzcx19/DmYfORNUpSZkk/0c=",
            "cpf": "U2FsdGVkX1/gFeaTy9H6NQ54ZCRfL7o244P22AYa2QU="
          }, {
            "num_cand": "U2FsdGVkX1/05LX6ZMqKknT6o0WnB+AWOKnpv41105g=",
            "cpf": "U2FsdGVkX1/0F7K+RNhy+NaDo5a4+u6dCW0cqfbWetU="
          }, {
            "num_cand": "U2FsdGVkX19/byx6q+65d9bqTsgv//y+IBLppBxBlXs=",
            "cpf": "U2FsdGVkX1/Qxpy9dSEI9liDRpqm+paa6MW8s9LhHv4="
          }, {
            "num_cand": "U2FsdGVkX19L9XMhn9bHrPHwRFYTIkeUQ/qwe6poEgE=",
            "cpf": "U2FsdGVkX1+hNCuLZsFh0iy5rnoAvy4427ey2TkXzq0="
          }, {
            "num_cand": "U2FsdGVkX19EIdafD8jY6BUdvJ/s0A9Pn8ZJ6SMY6Pk=",
            "cpf": "U2FsdGVkX19bR8RXZj4/eDo9fmtoXLYWz372Ly7r1pw="
          }, {
            "num_cand": "U2FsdGVkX19OaLmbFW7ZfJpjFonF2L3wRVw9RU7Q7zw=",
            "cpf": "U2FsdGVkX1+LyKwdWsLH9SLn9eBE/VQoZBzRjvuZdQQ="
          }, {
            "num_cand": "U2FsdGVkX1/ti+1Ui7cSzmDHkL0UYu8jMpK0IkN0tqc=",
            "cpf": "U2FsdGVkX19SdD88Mk5c/3GHgUAf3S8RRBNnE2B1O1I="
          }, {
            "num_cand": "U2FsdGVkX1+mc84rWGRO5PNGwerHTKg8WnF6dP6gMic=",
            "cpf": "U2FsdGVkX18tfYPO1AzNrDH69QFSABLjjK8JICX+6I0="
          }, {
            "num_cand": "U2FsdGVkX19l2uHZm2tyw83yQco1WP+mxLNYg94qXtc=",
            "cpf": "U2FsdGVkX19C3GsOqpZZPmczj2zy3txnzndEmyADPlA="
          }, {
            "num_cand": "U2FsdGVkX1+4+lbjzXKzTWWqhSuud1S59AyvDz+ROhQ=",
            "cpf": "U2FsdGVkX1/JHmNsSftAi4bDHN7hjuj1HRXz8TX07/Q="
          }, {
            "num_cand": "U2FsdGVkX19ECver0cwtfxzU0z4U1ljUt4oAK8FWAxY=",
            "cpf": "U2FsdGVkX18+eWCpcd3LVGlWI7AdngbSXA29olhuNxc="
          }, {
            "num_cand": "U2FsdGVkX186hVSDNNM7eaMHlWPyVGaLd3u2Bp+DEQk=",
            "cpf": "U2FsdGVkX1+ZH3Kd24Z7Tx/17xU75/GxIR0IrezsH68="
          }, {
            "num_cand": "U2FsdGVkX19umuD2zvsXEf15HfxkCpWDfWvNf5qHXI8=",
            "cpf": "U2FsdGVkX19O/vnXVi/2LYlpWSFw26ynPpWv/jQtOrE="
          }, {
            "num_cand": "U2FsdGVkX1+EfVtSX6Rt/1tUUD3lqM/J6hCAkm41R8Y=",
            "cpf": "U2FsdGVkX1/WOKrJ2hfJ7P4y6FFiBgD09rP50KyQFdw="
          }, {
            "num_cand": "U2FsdGVkX19MmD5k720j8ETAf/3QTjF1SLJ6fUU1eto=",
            "cpf": "U2FsdGVkX1/VqxnLfRDbtHRpFVOgdWUh7ivzKmu13Rw="
          }, {
            "num_cand": "U2FsdGVkX1+VD629SY1MNzN1vNRW+/tPpYjRSxAnPpA=",
            "cpf": "U2FsdGVkX1+8nEh1o9sZXLIBQuquKI+7oDhlC5v/mwA="
          }, {
            "num_cand": "U2FsdGVkX18sWYGwEeyb1Tz12Mku6JNs4h8bD1W0r80=",
            "cpf": "U2FsdGVkX1/5iiUmytm7y7DbkqPgAjAl5vAvnJaiIc4="
          }, {
            "num_cand": "U2FsdGVkX18h0reIbhpgYBejBFBUuedHhgsH4N4iDmU=",
            "cpf": "U2FsdGVkX1/VuHKBIhulo5zy2q6lA3Mc2uytFQKzX08="
          }, {
            "num_cand": "U2FsdGVkX1/u5Ay+RGrJlshzt7ViVeSjgGLExR/sqdU=",
            "cpf": "U2FsdGVkX18kBBvyiE+ttfL7nNSZL5c6ZY7cX6pi69Q="
          }, {
            "num_cand": "U2FsdGVkX19Sns7HAdz02L+POrB2Mi2kyfFJ4Tlefu8=",
            "cpf": "U2FsdGVkX1+61WWDz2A8yCX7VoXZDk8H7Ts89EawK+I="
          }, {
            "num_cand": "U2FsdGVkX19oeSV1YwHYM97kWO5s67LFArMcNaGM+Ok=",
            "cpf": "U2FsdGVkX18lxPtXfH8SKfFqAz5K3LwsBpcqhpCVbCw="
          }, {
            "num_cand": "U2FsdGVkX18WFujMtGmOtRQX+fGxPZOLyT4vYvVmaOY=",
            "cpf": "U2FsdGVkX1/+W+F+4fSXYmpZpNnpycOYXG4Ro5Ai+M8="
          }, {
            "num_cand": "U2FsdGVkX19a8OBEcyMcN/7OzfyAPlZySo5aracN+6I=",
            "cpf": "U2FsdGVkX1/jfF9tAYODpmlNL2j1OMJDqWBizUpnZaY="
          }, {
            "num_cand": "U2FsdGVkX1+IpLB3SWWYp4mPPBU1KM5E7Ylxf4IwvgM=",
            "cpf": "U2FsdGVkX1/8YjCfmNxyzohwCdHpQVlpEhig6XCSZNE="
          }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2114/2114_recx-titx/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
